var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UploadImages',{on:{"changed":_vm.handleImages}}),_vm._v(" "+_vm._s(_vm.files)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }